import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import CookieBanner from "./CookieBanner";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./Redux/store";
import Amplify from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import config from "./config.json";

// Import axios configuration to set up interceptors globally
import './axiosConfig';

// Initialize Google Analytics
import { initGA } from './utils/analytics';
initGA();

// Check if we're in development environment
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

let redirectUrl;
if (window.location.pathname === "/login") {
  if (window.location.search.includes("is_extension")) {
    localStorage.setItem('is_extension_login', true);
    redirectUrl = "https://www.app.datarate.io";
  } else {
    redirectUrl = "https://www.app.datarate.io";
  }
} else {
  redirectUrl = "https://www.app.datarate.io";
}

// Override for development
if (isLocalhost) {
  redirectUrl = "http://localhost:3000";
}

// Configure Amplify with cookie storage for secure token management
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    // SECURITY: Use cookieStorage instead of localStorage for tokens
    cookieStorage: {
      // In localhost, use 'localhost' domain (or empty for localhost)
      // In production, use '.datarate.io' to allow cookies across all subdomains (app.datarate.io, webapi.datarate.io, etc.)
      domain: isLocalhost ? 'localhost' : '.datarate.io',
      path: '/',
      expires: 365, // 1 year
      // In localhost, use 'lax' because HTTPS is usually not available
      // In production, use 'lax' to allow cookies to be sent to API subdomain (webapi.datarate.io)
      // 'lax' is still secure - it prevents CSRF while allowing same-site API calls
      sameSite: 'lax',
      // In localhost, secure must be false (no HTTPS)
      // In production, secure must be true (HTTPS only)
      secure: isLocalhost ? false : true
    },
    oauth: {
      domain: [config.cognito.USER_POOL_DOMAIN],
      scope: [
        "phone",
        "email",
        "profile",
        "openid",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn: isLocalhost ? "http://localhost:3000" : redirectUrl,
      redirectSignOut: isLocalhost
        ? "http://localhost:3000"
        : config.cognito.URL_REDIRECT_SIGNOUT,
      responseType: "code",
    },
  },
});

<Authenticator usernameAlias="email" />;

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
      <CookieBanner />
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
